/** @jsxImportSource react */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'theme-ui';
import { ErrorBoundary } from 'react-error-boundary';
import '@/index.css';
import { theme } from '@/lib/theme';
import { WalletContextProvider } from '@/context/WalletContext';
import { EffectContextProvider } from '@/context/EffectContext';
import { RecaptchaProvider } from '@/providers/RecaptchaProvider';
import { WagmiProvider } from '@/providers/WagmiProvider';
import { MuteContextProvider } from '@/context/MuteContext';
import { ErrorFallback } from '@/components/ErrorFallback';
import { BloomSelectionContextProvider } from '@/context/BloomSelectionContext';
import { RouterContextProvider } from '@/context/RouterContext';
import { DprContextProvider } from '@/context/DprContext';
import { Views } from '@/components/Views';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find root element');

const root = createRoot(container);
root.render(
    <React.StrictMode>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <RecaptchaProvider>
                <WagmiProvider>
                    <WalletContextProvider>
                        <EffectContextProvider>
                            <ThemeProvider theme={theme}>
                                <MuteContextProvider>
                                    <BloomSelectionContextProvider>
                                        <DprContextProvider>
                                            <RouterContextProvider>
                                                <Views />
                                            </RouterContextProvider>
                                        </DprContextProvider>
                                    </BloomSelectionContextProvider>
                                </MuteContextProvider>
                            </ThemeProvider>
                        </EffectContextProvider>
                    </WalletContextProvider>
                </WagmiProvider>
            </RecaptchaProvider>
        </ErrorBoundary>
    </React.StrictMode>
);
